import { render, staticRenderFns } from "./capsuleBanner.vue?vue&type=template&id=361b5594&scoped=true&"
import script from "./capsuleBanner.vue?vue&type=script&lang=js&"
export * from "./capsuleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b5594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('361b5594')) {
      api.createRecord('361b5594', component.options)
    } else {
      api.reload('361b5594', component.options)
    }
    module.hot.accept("./capsuleBanner.vue?vue&type=template&id=361b5594&scoped=true&", function () {
      api.rerender('361b5594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/capsuleBanner.vue"
export default component.exports